
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Josef G., 84, verstorben am 24. Oktober 2020</b>
    <br />
    <br />
    <i>Seine Ehefrau sagt:</i>
    <br />
    <p>
  «Mein Mann war kerngesund. Den ganzen Sommer über gingen wir täglich zwei
  Stunden spazieren. Beim Einkaufen trug er eine Maske, überhaupt immer, und das
  schon sehr früh. Nur ein einziges Mal im Oktober vergass er sie – als er einem
  jungen Mann etwas erklärte, der ebenfalls keine Maske trug. Der steckte ihn
  an.
    </p>
    <p>
  Etwa eine Woche später kamen erste Symptome: Kältegefühle, Müdigkeit,
  eigentlich wie eine Erkältung. Rasch kam starkes Rückenweh dazu. Aber kein
  Fieber.
    </p>
    <p>
  Als das Rückenweh immer schlimmer wurde, rief ich unsere Hausärztin an. Sogar
  zweimal. Doch sie meinte, da müsse er durch. Eine Covid-Erkrankung könne gut
  zwei oder drei Wochen dauern. Zwei Tage vor seinem Tod legte sich mein Mann
  ins Bett, weil das Rückenweh kaum mehr auszuhalten war. Als ich nach ihm
  schaute, war er bereits nicht mehr richtig ansprechbar. Ich mass Fieber – doch
  irgendwie funktionierte das Thermometer nicht. Da merkte ich, was der Grund
  war: Er hatte 42 Grad Celsius.
    </p>
    <p>
  Ich wählte die 144. Eine Stunde später rief mich eine Ärztin aus der
  Intensivstation an. Es tue ihr so leid, sagte sie, aber sie könne meinem Mann
  nicht mehr helfen. Seine Lunge sei in einem ganz, ganz schlechten Zustand. Er
  werde sterben.
    </p>
    <p>
  Das war ein unglaublicher Schock für mich. Er hatte nie Atemnot gehabt, nur
  diese schlimmen Rückenschmerzen. Heute weiss ich, dass Lungenentzündungen
  Rückenweh auslösen können – aber wir hatten ja keine Ahnung.
    </p>
    <p>
  Hätte man doch seine Lunge abgehört. Überhaupt hat uns niemand geholfen. Bis
  er nur schon einen Corona-Test machen konnte! An vier Orten rief ich an,
  überall wies man uns ab. Bei mir war es genau gleich. Ich steckte mich bei
  meinem Mann an, bekam Atemnot, doch unsere Hausärztin wollte mich nicht
  testen. Sie konnte mir auch nicht sagen, wo ich hingehen soll. Es war
  Wahnsinn. Es ging so schnell.
    </p>
    <p>
  Mein Mann hat immer gearbeitet. Er hat stets allen geholfen. Er lebte so gern.
  Er wollte nicht sterben.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;